import { MutableRefObject } from "react";

import { useTranslation } from "react-i18next";

import {
  BodyWaterMark,
  Box,
  ContainerCheckboxList,
  ContainerSelectTypeMark,
  ContainerWaterMaker,
} from "./styles";
import { CheckBoxGlobal } from "../../../../../components/CheckBoxGlobal";
import { DropdownGlobal } from "../../../../../components/DropdownGlobal";
import { InputGeneralFile } from "../../../../../components/InputFileGlobal";
import { getListWaterMarkProvider, getListYesOrNoAux } from "../../constants";
import { ISystemWatermark } from "../../interface";

interface WatermarkCustomProps {
  fieldError: boolean;
  setEditedValue: any;
  selectedYesOrNoName: any;
  editedValue: any;
  setFile: any;
  selectType: any;
  typeMark: any;
  labelList: any;
  setLabelList: any;
  filePathMark: any;
  systemWaterMark: MutableRefObject<ISystemWatermark | undefined>;
  getNameIfIdMatches: (array: any[], editedValue: string) => any;
}

const WatermarkCustom = ({
  fieldError,
  setEditedValue,
  selectedYesOrNoName,
  editedValue,
  setFile,
  selectType,
  typeMark,
  labelList,
  setLabelList,
  filePathMark,
  systemWaterMark,
  getNameIfIdMatches,
}: WatermarkCustomProps) => {
  const { t } = useTranslation();
  const listYesOrNoAux = getListYesOrNoAux(t);
  const listWaterMarkProvider = getListWaterMarkProvider(t);

  const getWatermarkProvider = () => systemWaterMark?.current?.provider ?? -1;

  const handleWatermarkProvider = (id: number) => {
    if (systemWaterMark.current) {
      systemWaterMark.current.provider = id;
    }
  };

  const toggleLabel = (label: string) => {
    if (labelList.includes(label)) {
      setLabelList(labelList?.filter((x: string) => x !== label));
    } else {
      setLabelList([...labelList, label]);
    }
  };

  return (
    <ContainerWaterMaker>
      <DropdownGlobal
        labelName={t("watermark.add")}
        options={listYesOrNoAux}
        error={fieldError}
        setSelected={(e: any) => {
          setEditedValue(String(e));
        }}
        required={false}
        editDropdown={selectedYesOrNoName}
        defaultValue={selectedYesOrNoName}
      />
      <DropdownGlobal
        labelName={t("watermark.provider")}
        options={listWaterMarkProvider}
        error={fieldError}
        setSelected={(e: any) => handleWatermarkProvider(e)}
        required={false}
        editDropdown={getNameIfIdMatches(
          listWaterMarkProvider,
          getWatermarkProvider().toString(),
        )}
        defaultValue={getNameIfIdMatches(
          listWaterMarkProvider,
          getWatermarkProvider().toString(),
        )}
      />
      {(selectedYesOrNoName === "1" || editedValue === "1") && (
        <>
          <InputGeneralFile
            label={t("watermark.logoUpload")}
            type="file"
            onChange={(file: any) => setFile(file)}
            defaultValue={filePathMark}
          />
          <BodyWaterMark>
            <span>{t("watermark.layout")}</span>
            <ContainerSelectTypeMark>
              <Box onClick={() => selectType(1)} marginTop="50px">
                <div>
                  <input
                    defaultChecked={typeMark === 1}
                    checked={typeMark === 1}
                    onChange={() => selectType(1)}
                    type="radio"
                  />
                  <span>{t("watermark.caption")}</span>
                </div>
              </Box>
              <Box
                onClick={() => selectType(2)}
                alignItems="flex-end"
                marginTop="50px"
              >
                <div>
                  <input
                    defaultChecked={typeMark === 2}
                    checked={typeMark === 2}
                    onChange={() => selectType(2)}
                    type="radio"
                  />
                  <span>{t("watermark.caption")}</span>
                </div>
              </Box>
            </ContainerSelectTypeMark>
            <ContainerSelectTypeMark>
              <Box onClick={() => selectType(3)} marginBottom="50px">
                <div>
                  <span>{t("watermark.caption")}</span>
                  <input
                    defaultChecked={typeMark === 3}
                    checked={typeMark === 3}
                    onChange={() => selectType(3)}
                    type="radio"
                  />
                </div>
              </Box>
              <Box
                onClick={() => selectType(4)}
                alignItems="flex-end"
                marginBottom="50px"
              >
                <div>
                  <span>{t("watermark.caption")}</span>
                  <input
                    defaultChecked={typeMark === 4}
                    checked={typeMark === 4}
                    onChange={() => selectType(4)}
                    type="radio"
                  />
                </div>
              </Box>
            </ContainerSelectTypeMark>
          </BodyWaterMark>

          <ContainerCheckboxList>
            <CheckBoxGlobal
              checked={labelList.includes("PlaceName")}
              id={1}
              label={t("watermark.unit")}
              onChecked={() => toggleLabel("PlaceName")}
            />
            <CheckBoxGlobal
              checked={labelList.includes("ProcedureNumber")}
              id={2}
              label={t("watermark.procedureNumber")}
              onChecked={() => toggleLabel("ProcedureNumber")}
            />
            <CheckBoxGlobal
              checked={labelList.includes("HearingId")}
              id={3}
              label={t("watermark.recordingNumber")}
              onChecked={() => toggleLabel("HearingId")}
            />
            <CheckBoxGlobal
              checked={labelList.includes("ExpectedDate")}
              id={4}
              label={t("watermark.recordingDate")}
              onChecked={() => toggleLabel("ExpectedDate")}
            />
          </ContainerCheckboxList>
        </>
      )}
    </ContainerWaterMaker>
  );
};

export default WatermarkCustom;
